import React, { Component } from 'react';
import moment from 'moment';

import AskForOffer from './ask_for_offer/ask_for_offer';
import { T } from '../../../../../common/locale/translate';
import { link2OfferReservation } from '../../../services/services';
import { offerTypes } from '../../../common/objects/offer_types';
import DepartureFromGermany from '../../../common/components/departure_from_germany';

export default class OfferDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      details: this.props.details
    };
  }

  render() {
    const details = this.state.details;
    const adults = this.prepareAdultsVerb(details);
    const children = this.prepareChildrenVerb(details);
    const operatorLogoUrl = details.operatorLogoUrl;
    const reservationUrl = link2OfferReservation(this.reservationParams());
    const reservationWithPaymentUrl = `${link2OfferReservation(
      this.reservationParams()
    )}&payment=true`;
    const paymentMethods = this.props.offer.inkasso_list
      ? this.props.offer.inkasso_list
          .filter(x => x['type'] != 'paypal')
          .filter(x => x['type'] != 'invoice')
      : null;

    return (
      <div className="offer-details">
        <div className="container">
          <ul className="col-1">
            <li>
              <span className="fa fa-calendar" />
              {`${moment(details.departure_date).format('DD.MM')} - ${moment(
                details.return_date
              ).format('DD.MM')} / ${details.trip_duration} ${T('days')}`}
            </li>
            {details.offerType != offerTypes.hotel_only && (
              <li className="flight-airport-info">
                <span className="fa fa-plane" />
                <div className="departure-container">
                  <a
                    href="javascript:void(0)"
                    rel="nofollow"
                    onClick={this.handleClick}
                  >
                    {details.flight_from}
                  </a>
                  {details.is_departure_from_germany && (
                    <DepartureFromGermany />
                  )}
                </div>
              </li>
            )}
            {details.offerType != offerTypes.hotel_only && (
              <li className="flight-airport-info">
                <span className="fa fa-plane" />
                <a
                  href="javascript:void(0)"
                  rel="nofollow"
                  onClick={this.handleClick}
                >
                  {details.flight_to}
                </a>
              </li>
            )}
          </ul>
          <ul className="col-2">
            <li>
              <span className="fa fa-child" />
              {`${details.adults_number} ${adults}, ${
                details.children_number
              } ${children}`}
            </li>
            <li>
              <span className="fa fa-cutlery" />
              {details.alimentation}
            </li>
            <li>
              <span className="fa fa-bed" />
              {details.accommodation}
            </li>
          </ul>
          <ul className="provider">
            <li>
              {operatorLogoUrl != null && (
                <img className="operator-logo" src={operatorLogoUrl} alt="" />
              )}
              <span className="operator-name">{details.operator}</span>
            </li>
          </ul>
        </div>

        <div className="details-summary">
          {paymentMethods &&
            paymentMethods.length > 0 && (
              <div className="payment-methods-wrapper">
                {paymentMethods.map(payment => (
                  <div
                    className={`payment-icon${
                      payment.label ? ' has-tooltip' : ''
                    }`}
                    {...payment.label && {
                      title: payment.label
                    }}
                  >
                    {this.renderPaymentMethods(payment)}
                  </div>
                ))}
              </div>
            )}
          <div className="prices-wrapper hidden-m">
            {details.isOfferAvailable && (
              <div className="person-prices">
                <span className="pln">
                  {`${Math.ceil(details.person_pln)} zł`}
                </span>
                <span className="per-person">{T('per_person')}</span>
              </div>
            )}
            {details.isOfferAvailable && (
              <div className="summary-price">
                <span className="pln">
                  {`${Math.ceil(details.total_pln)} zł `}
                </span>
                <span className="eur">
                  ({Math.ceil(details.total_eur)} &euro;){' '}
                </span>
                {T('together')}
              </div>
            )}
          </div>
          {!details.isOfferAvailable && (
            <div className="not-available-message"> {details.message} </div>
          )}
          {details.isOfferAvailable && (
            <div className="order-button-wrapper">
              <div className="prices-wrapper mobile-prices">
                {details.isOfferAvailable && (
                  <div className="person-prices">
                    <span className="pln">
                      {`${Math.ceil(details.person_pln)} zł`}
                    </span>
                    <span className="per-person">{T('per_person')}</span>
                  </div>
                )}
                {details.isOfferAvailable && (
                  <div className="summary-price">
                    <span className="pln">
                      {`${Math.ceil(details.total_pln)} zł `}
                    </span>
                    <span className="eur">
                      ({Math.ceil(details.total_eur)} &euro;){' '}
                    </span>
                    {T('together')}
                  </div>
                )}
              </div>
              {details.parser === 'traffics' && (
                <div className="book-offer-pay-now">
                  <i className="fa fa-exclamation-circle padding-right-10" />
                  {T('pay_now_reservation')}
                </div>
              )}
              <div className="book-offer-button-wrapper">
                <a
                  rel="nofollow"
                  title={T('book_offer')}
                  className="book-offer"
                  href={reservationUrl}
                >
                  {' '}
                  {T('send_reservation')}{' '}
                </a>
              </div>
              {details.parser === 'traffics' &&
                paymentMethods &&
                paymentMethods.length > 0 && (
                  <div className="book-offer-button-wrapper">
                    <a
                      rel="nofollow"
                      title={T('book_offer')}
                      className="book-offer"
                      href={reservationWithPaymentUrl}
                    >
                      {' '}
                      {T('send_reservation_and_pay')}{' '}
                    </a>
                  </div>
                )}
            </div>
          )}
          <AskForOffer
            offer={this.props.offer}
            token={this.props.token}
            type="offer"
            className="reservation-ask-for-offer"
            params={this.props.params}
          />
        </div>
      </div>
    );
  }

  renderPaymentMethods = paymentMethod => {
    switch (paymentMethod.code) {
      case 'VI':
        return <img src="/img/icons/visa.svg" alt={paymentMethod.type} />;
      case 'MC':
        return (
          <img src="/img/icons/master_card.svg" alt={paymentMethod.type} />
        );
      case 'EC':
        return [
          <img src="/img/icons/master_card.svg" alt={paymentMethod.type} />,
          <span className="master-card-ec">(EC)</span>
        ];
      case 'AX':
        return <img src="/img/icons/amex.svg" alt={paymentMethod.type} />;
      case 'PP':
        return <img src="/img/icons/paypal.svg" alt={paymentMethod.type} />;
      case 'RE':
      case 'SE':
      case 'BE':
      default:
        return T(paymentMethod.type);
    }
  };

  handleClick = () => {
    this.props.openFlightDetails();
  };

  prepareAdultsVerb = details => {
    return details.adults_number === 1
      ? T('adult')
      : T('adults_selected_plural');
  };
  prepareChildrenVerb = details => {
    return details.children_number === 1
      ? T('child')
      : T('children_selected_plural');
  };

  reservationParams = () => {
    const details = this.state.details;
    return {
      id: details.id,
      operator_code: details.operatorCode,
      parser: details.parser,

      offer_id: details.offerId,
      offer_type: details.offerType,

      adults_number: details.adults_number,
      children_ages: details.children_ages,

      departure_date: moment(details.departure_date).unix(),
      return_date: moment(details.return_date).unix()
    };
  };
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offer/components/offer_details.jsx